import React, { ChangeEvent } from 'react';

interface SelectColumnsProps {
  data: any[];
  selectedColumns: string[];
  setSelectedColumns: any;
  alwaysVisible?: string[];
}

export const SelectColumns: React.FC<SelectColumnsProps> = ({ data, selectedColumns, setSelectedColumns, alwaysVisible }) => {
  const alwaysSet = new Set(alwaysVisible || [])
  const allColumns = data && data[0] ? data[0].map((item: any) => item.title) : []
  const allSelected = allColumns.length > 0 && allColumns.every((t: string) => selectedColumns.includes(t))
  const noneSelected = allColumns.length > 0 && !allColumns.some((t: string) => selectedColumns.includes(t) && !alwaysSet.has(t))

  const handleColumnToggle = (columnTitle: string) => {
    if (alwaysSet.has(columnTitle)) return
    setSelectedColumns((prevSelectedColumns: any) => {
      if (prevSelectedColumns.includes(columnTitle)) {
        return prevSelectedColumns.filter((title: string) => title !== columnTitle);
      } else {
        return [...prevSelectedColumns, columnTitle];
      }
    });
  };

  const handleSelectAll = () => setSelectedColumns(allColumns)
  const handleDeselectAll = () => setSelectedColumns(allColumns.filter((t: string) => alwaysSet.has(t)))

  return (
    <div className="column-selector">
        <div className="column-selector-actions">
          <button type="button" onClick={handleSelectAll} disabled={allSelected}>Select All</button>
          <button type="button" onClick={handleDeselectAll} disabled={noneSelected}>Deselect All</button>
        </div>
        {allColumns.map((title: string, index: number) => (
          <label key={index} style={alwaysSet.has(title) ? { opacity: 0.5, cursor: 'default' } : undefined}>
            <input
              type="checkbox"
              checked={selectedColumns.includes(title)}
              onChange={() => handleColumnToggle(title)}
              disabled={alwaysSet.has(title)}
            />
            {title.toUpperCase()}
          </label>
        ))}
      </div>
  );
};
